<div class="white-section py-3 px-lg-5 px-md-4 px-3">
  <h1 class="section-header mb-0">Welcome</h1>
  <div class="h3-text">To Your Nicola Wealth Private {{ accessType === 'accountant' ? 'Accountant' : 'Client' }} Access Website</div>

  @if (sessionTimedOut) {
    <div class="py-4">
      <span class="text-alert">
        Your session has timed out due to inactivity.
      </span>
      <br/>Please log in again to access your account.
    </div>
  }

  <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate>
    <div class="form-group" style="position:relative;">
      <label for="username" style="font-size:16px;font-weight: bold;font-variation-settings:'wght' 600">Username</label>
      <!--   In iPhone, the text inside the input is sometimes auto-capitalized so autocapitalize="off" is set to the element   -->
      <input type="text" id="username"  autocomplete="off" class="form-control" name="username" autocapitalize="off" [(ngModel)]="username" required [disabled]="sentcode" />
      @if (sentcode===true) {
        <i class="fa fa-check checkIcon"></i>
      }
    </div>
    <div class="form-group" style="position:relative;">
      <label for="password" style="font-size:16px;font-weight: bold;font-variation-settings:'wght' 600">Password</label>
      <input type="password" id="password" autocomplete="off" class="form-control" name="password" [(ngModel)]="password" required [disabled]="sentcode" />
      <span class="material-icons-outlined passwordEye">visibility</span>
      @if (sentcode===true) {
        <i class="fa fa-check checkIcon"></i>
      }
    </div>

    <caps-lock />

    @if (sentcode!==true) {
      <div class="form-group">
        <button class="btn-primary w-100" [disabled]="f.form.invalid" (click)="login()">Log In</button>
      </div>
    }

    @if (sentcode!==true) {
      <div>
        @if (config.demoSite) {
          <span class="demo-disabled" title="This functionality is not available on Demo Web Site">Forgot Username/Password</span>
        }
        @if (!config.demoSite) {
          <a routerLink="/account/loginhelp" style="font-weight: bold;font-variation-settings:'wght' 600;text-decoration: underline;">Forgot Username/Password</a>
        }
      </div>
    }
<!--    @if (msLoginUrl) {-->
<!--      <div class="form-group">-->
<!--        <div class="row">-->
<!--          <div class="col-12">-->
<!--            <a href="{{msLoginUrl}}">-->
<!--              <img src="assets/images/ms-symbollockup_signin_light.svg" alt="Sign in with Microsoft"/>-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    }-->

    <div class="row">
      <div class="col-12" >
        @if (errorMsg) {
          <div class="alert alert-danger">{{errorMsg}}</div>
        }
      </div>
    </div>

    @if (sentcode===true) {
      <nwm-tfa [providers]="TfaProviders" [isLogin]="true" (timeOut)="tfaTimeOut()" (tfaSuccess)="tfaPassed($event)" />
    }
  </form>

  <p class="mt-3 mb-2">
    Not registered yet? Please contact a member of our <a href="mailto:clientservices@nicolawealth.com">Client Services Team</a> to arrange access.
  </p>

  @if (config.mobileAppShowLinks) {
    <p>
      Download our mobile app on Apple or Android
      <a href="{{config.mobileAppIphoneLink}}" aria-label="Mobile app on Apple" class="ml-4" style="color:#183750;font-size: 24px;"><i class="fa fa-apple" aria-hidden="true"></i></a>
      <a href="{{config.mobileAppAndroidLink}}" class="ml-4" aria-label="Mobile app on Android" style="color:#183750;font-size: 24px;"><i class="fa fa-android" aria-hidden="true"></i></a>
    </p>
  }

  <nwm-awards />
</div>
